import { FieldAnswer } from '@app/api';
import { useCallback, useMemo, useState } from 'react';

const createFieldChoiceStorageItem = (
  screenerFormId: string,
  fieldType: string,
) => `${fieldType}_${screenerFormId}`;

export const useFieldChoice = (
  screenerFormId: string | undefined,
  fieldType: string,
) => {
  const initialValue = useMemo(() => {
    if (!screenerFormId) {
      return undefined;
    }
    const item = sessionStorage.getItem(
      createFieldChoiceStorageItem(screenerFormId, fieldType),
    );
    if (item) {
      return JSON.parse(item);
    }
    return undefined;
  }, [screenerFormId, fieldType]);

  const [value, setValueState] = useState<FieldAnswer>(initialValue);

  const setValue = useCallback(
    (answer: FieldAnswer) => {
      sessionStorage.setItem(
        createFieldChoiceStorageItem(screenerFormId!, fieldType),
        JSON.stringify(answer),
      );
      setValueState(answer);
    },
    [screenerFormId, fieldType],
  );

  return {
    value,
    setValue,
  };
};